export default "__VITE_ASSET__7a26556e__"